import React from 'react';
import { Link } from 'react-router-dom';

function FeaturesDetail() {
  const features = [
    {
      id: 1,
      title: "Project Management System",
      icon: "fas fa-project-diagram",
      description: "Acuit CRM includes a full-fledged project and task management suite that helps teams stay organized and productive.",
      benefits: [
        "Create, assign, and manage projects with ease",
        "Track billable and non-billable time",
        "Set milestones and monitor real-time progress",
        "Maintain project budgets and expenses",
        "View deadlines through an integrated project calendar",
        "Improve team collaboration with project discussions and task comments"
      ],
      seoKeywords: "project management software Malaysia, team collaboration tool, task tracking CRM"
    },
    {
      id: 2,
      title: "Invoicing & Estimates (Billing Automation)",
      icon: "fas fa-file-invoice-dollar",
      description: "Simplify your financial processes with Acuit CRM's professional invoicing tools.",
      benefits: [
        "Create branded invoices and export them as PDFs",
        "Support for recurring invoices and automated billing cycles",
        "Convert estimates, quotations, and proposals into invoices instantly",
        "Accept online payments via PayPal, Stripe, and other gateways",
        "Track invoice status, partial payments, credit notes, and more"
      ],
      seoKeywords: "invoicing software Malaysia, billing automation system, online payment CRM"
    },
    {
      id: 3,
      title: "Proposal Builder",
      icon: "fas fa-file-alt",
      description: "Close deals faster with visually stunning, interactive proposals.",
      benefits: [
        "Create proposal documents with images, videos, tables, and formatting",
        "Allow clients to comment, request changes, or approve online",
        "Full e-signature support for faster deal closure",
        "Track proposal views, acceptance, and client activity"
      ],
      seoKeywords: "proposal management system, digital proposal builder, e-signature CRM"
    },
    {
      id: 4,
      title: "Lead Management & Sales Pipeline",
      icon: "fas fa-users",
      description: "Manage your leads effectively using Acuit CRM's Kanban-style sales pipeline.",
      benefits: [
        "Drag-and-drop lead movement through pipeline stages",
        "Automatic lead capture from emails or web forms",
        "Assign leads to specific sales agents",
        "Convert leads to customers with a single click",
        "Track communication history, notes, files, and follow-ups"
      ],
      seoKeywords: "lead management system, sales CRM Malaysia, pipeline tracking tool"
    },
    {
      id: 5,
      title: "Expenses & Payments Tracking",
      icon: "fas fa-money-bill-wave",
      description: "Gain full control over company spending and revenue.",
      benefits: [
        "Log daily expenses and categorize them",
        "Set recurring expenses such as supplier fees or subscriptions",
        "Track payment history and outstanding balances",
        "Receive online payments directly from clients"
      ],
      seoKeywords: "expense tracking software, financial management CRM, online payment tracking"
    },
    {
      id: 6,
      title: "Customer Support Ticketing System",
      icon: "fas fa-headset",
      description: "Offer professional customer support using the CRM's integrated ticketing solution.",
      benefits: [
        "Convert emails into support tickets",
        "Pre-defined replies for faster resolutions",
        "Staff internal notes for collaboration",
        "Attach files, screenshots, documents",
        "Track SLAs, ticket priority, status, and response times"
      ],
      seoKeywords: "customer support system, helpdesk CRM, ticket management software"
    },
    {
      id: 7,
      title: "Contracts & E-Signature Module",
      icon: "fas fa-file-signature",
      description: "Manage business contracts from creation to approval.",
      benefits: [
        "Create contract templates with custom fields",
        "Send contracts for approval electronically",
        "E-signature support for proposals, estimates, invoices, and contracts",
        "Track contract start/end dates and renewals"
      ],
      seoKeywords: "contract management system, digital signature CRM, e-contract software"
    },
    {
      id: 8,
      title: "Survey Builder",
      icon: "fas fa-poll",
      description: "Gather insights and feedback from clients or team members.",
      benefits: [
        "Build custom surveys with multiple question types",
        "Send surveys via email",
        "Receive real-time analytics and summary charts",
        "Improve customer satisfaction and service quality"
      ],
      seoKeywords: "customer survey tool, feedback analytics CRM"
    },
    {
      id: 9,
      title: "Goal Tracking",
      icon: "fas fa-bullseye",
      description: "Monitor team performance and company KPIs.",
      benefits: [
        "Set monthly or yearly targets",
        "Track goal completion percentages",
        "Assign goals to teams or individuals",
        "Generate performance-based insights"
      ],
      seoKeywords: "performance goals CRM, KPI tracking tool, business analytics"
    },
    {
      id: 10,
      title: "Custom Fields",
      icon: "fas fa-edit",
      description: "Personalize Acuit CRM to match your business workflow.",
      benefits: [
        "Add custom fields to leads, clients, invoices, projects, tickets, etc.",
        "Tailor data collection to industry-specific needs",
        "Improve data accuracy and reporting capability"
      ],
      seoKeywords: "customizable CRM, CRM with custom fields"
    },
    {
      id: 11,
      title: "Reporting & Analytics Dashboard",
      icon: "fas fa-chart-bar",
      description: "Make informed business decisions using Acuit CRM's powerful analytics.",
      benefits: [
        "Sales reports, income vs. expenses charts",
        "Lead conversion reports",
        "Project profitability tracking",
        "Staff activity and performance analysis",
        "Financial forecasting tools"
      ],
      seoKeywords: "CRM reporting system, analytics dashboard, business intelligence CRM"
    },
    {
      id: 12,
      title: "Company Newsfeed",
      icon: "fas fa-newspaper",
      description: "Enhance team communication.",
      benefits: [
        "Share internal announcements, updates, and documents",
        "Improve team engagement and transparency"
      ],
      seoKeywords: "company announcements system, internal communication CRM"
    },
    {
      id: 13,
      title: "User & Staff Management",
      icon: "fas fa-user-shield",
      description: "Control access and improve system security.",
      benefits: [
        "Advanced role-based permissions",
        "Staff-specific file directories",
        "Designate admins, managers, and basic users",
        "Activity logs for accountability"
      ],
      seoKeywords: "user management CRM, staff permissions system"
    },
    {
      id: 14,
      title: "Security & Permissions",
      icon: "fas fa-lock",
      description: "Keep your business data secure and compliant.",
      benefits: [
        "HTTPS enforcement for secure communication",
        "Client permission control",
        "Access restrictions on modules and files",
        "GDPR-ready features for data protection"
      ],
      seoKeywords: "secure CRM system, GDPR compliant CRM"
    },
    {
      id: 15,
      title: "Updates & Version Enhancements",
      icon: "fas fa-sync-alt",
      description: "Acuit CRM continues to improve with modern features.",
      benefits: [
        "GDPR compliance",
        "Email verification system",
        "Google Drive file picker",
        "Automated task reminders",
        "UI/UX improvements for user friendliness"
      ],
      seoKeywords: "CRM updates, CRM new features, modern CRM software"
    },
    {
      id: 16,
      title: "SaaS Module (Optional Add-On)",
      icon: "fas fa-cloud",
      description: "Turn Acuit CRM into your own multi-tenant SaaS platform.",
      benefits: [
        "Charge monthly/annual subscription fees",
        "Create unlimited customer accounts",
        "Offer tier-based pricing (Starter, Pro, Enterprise)",
        "Automate activation, suspension, and billing"
      ],
      seoKeywords: "SaaS CRM Malaysia, white-label CRM system, multi-tenant CRM"
    }
  ];

  return (
    <>
      <section className="page-banner bg-blue rel z-1" style={{backgroundImage: 'url(/assets/images/background/banner-bg.png)'}}>
        <div className="container">
          <div className="banner-inner">
            <h1 className="page-title wow fadeInUp delay-0-2s">Detailed Features</h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb wow fadeInUp delay-0-4s">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item"><Link to="/features">Features</Link></li>
                <li className="breadcrumb-item active">Detailed Features</li>
              </ol>
            </nav>
          </div>
        </div>
        <img className="dots-shape" src="/assets/images/shapes/white-dots-two.png" alt="Shape" />
        <img className="tringle-shape slideLeftRight" src="/assets/images/shapes/white-tringle.png" alt="Shape" />
        <img className="close-shape" src="/assets/images/shapes/white-close.png" alt="Shape" />
        <img src="/assets/images/newsletter/circle.png" alt="shape" className="banner-circle slideUpRight" />
        <img className="dots-shape-three slideUpDown delay-1-5s" src="/assets/images/shapes/white-dots-three.png" alt="Shape" />
      </section>

      <section className="projects-details-section pt-130 rpt-100 pb-135 rpb-75">
        <div className="container">
          <div className="project-details-content">
            <div className="project-content-two wow fadeInUp delay-0-2s">
              <h2>17 Powerful Features to Transform Your Business</h2>
              <p>Acuit CRM offers a comprehensive suite of features designed to help small businesses, freelancers, startups, and growing agencies manage every aspect of their operations from a single dashboard.</p>
            </div>
          </div>
          <div className="row">
            {features.map((feature, index) => (
              <div key={feature.id} className="col-lg-6 mb-4">
                <div className="feedback-item-two wow fadeInUp" style={{animationDelay: `${index * 0.1}s`, minHeight: '400px'}}>
                  <div className="d-flex align-items-center mb-3">
                    <i className={feature.icon} style={{fontSize: '32px', color: '#0066cc', marginRight: '15px'}}></i>
                    <h4>{feature.title}</h4>
                  </div>
                  <p className="text-justify mb-3">{feature.description}</p>
                  <ul className="list-style-one">
                    {feature.benefits.map((benefit, idx) => (
                      <li key={idx}>{benefit}</li>
                    ))}
                  </ul>
                  <div className="mt-3">
                    <small className="text-muted"><strong>SEO Keywords:</strong> {feature.seoKeywords}</small>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-section-three rel z-1 pt-130 rpt-100 pb-130 rpb-100 bg-lighter">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8 text-center">
              <div className="section-title mb-30">
                <h2>Ready to Experience All These Features?</h2>
                <p>Get started with Acuit CRM today and transform the way you manage your business.</p>
              </div>
              <Link to="/contact" className="theme-btn style-three mr-3">Request Free Demo <i className="fas fa-arrow-right"></i></Link>
              <Link to="/pricing" className="theme-btn">View Pricing <i className="fas fa-arrow-right"></i></Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FeaturesDetail;

